import AbstractPageBaseController from '../../../modules/core/abstracts/controllers/page-controller';

export default class SettingsIndexPageController extends AbstractPageBaseController {
    
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/index-controller.js